import React from "react";
import "./App.css";
import "./responsive.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import SingleProduct from "./screens/SingleProduct";
import CartScreen from "./screens/CartScreen";
import NotFound from "./screens/NotFound";
import CategoriesScreen from "./screens/CategoriesScreen";
import CatalogProductsPage from "./screens/CatalogProductsPage";
import QuienesSomosScreen from "./screens/footer/AboutScreen";
import MisionVisionScreen from "./screens/footer/MissionVisionScreen";
import PoliticaPrivacidadScreen from "./screens/footer/PrivacyPolicyScreen";
import TerminosServicioScreen from "./screens/footer/TermsOfServiceScreen";
import PoliticaEnvioScreen from "./screens/footer/ShippingPolicyScreen";
import PoliticaDevolucionScreen from "./screens/footer/ReturnPolicyScreen";
import SummaryCartScreen from "./screens/SummaryCartScreen";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" component={HomeScreen} exact />
        <Route path="/search/:keyword" component={HomeScreen} exact />
        <Route path="/page/:pagenumber" component={HomeScreen} exact />
        <Route
          path="/search/:keyword/page/:pageNumber"
          component={HomeScreen}
          exact
        />

        <Route path="/categorias" component={CategoriesScreen} exact />
        <Route
          path="/categorias/page/:pageNumber"
          component={CategoriesScreen}
          exact
        />

        <Route
          path="/categorias/:categorySlug/departamento/:departmentSlug"
          component={CatalogProductsPage}
          exact
        />

        <Route
          path="/categorias/:categorySlug/departamento/:departmentSlug/page/:pageNumber"
          component={CatalogProductsPage}
          exact
        />

        <Route path="/categorias/:slug" component={CatalogProductsPage} exact />

        <Route
          path="/categorias/:slug/page/:pageNumber"
          component={CatalogProductsPage}
          exact
        />

        <Route path="/destacados" component={HomeScreen} exact />
        <Route path="/destacados/page/:pageNumber" component={HomeScreen} exact />

        <Route path="/quienes-somos" component={QuienesSomosScreen} exact />
        <Route path="/mision-vision" component={MisionVisionScreen} exact />
        <Route
          path="/politica-de-privacidad"
          component={PoliticaPrivacidadScreen}
          exact
        />
        <Route
          path="/terminos-del-servicio"
          component={TerminosServicioScreen}
          exact
        />
        <Route path="/politica-de-envio" component={PoliticaEnvioScreen} exact />
        <Route
          path="/politica-de-devolucion"
          component={PoliticaDevolucionScreen}
          exact
        />

        <Route path="/products/:id" component={SingleProduct} exact />
        <Route path="/cart-summary" component={SummaryCartScreen} exact />
        <Route path="/cart/:id?" component={CartScreen} exact />

        <Route path="*" component={NotFound} />
      </Switch>
    </Router>
  );
};

export default App;